
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/file-input/file-input-list-item.component.js'
      import type { DdsFileRemoveEvent } from '../../events/events'
import type { DdsFileClickEvent } from '../../events/events'
      export type { DdsFileRemoveEvent } from '../../events/events'
export type { DdsFileClickEvent } from '../../events/events'

      const tagName = 'dap-ds-file-input-list-item'

      /**
 * `dap-ds-file-input-list-item`
 * @summary A file input list item is a container for file input list items.
 * @element dap-ds-file-input-list-item
 * @title - File input list item
 * @group file-input
 *
 * @event {{ file: FileListElement }} dds-file-remove - Dispatched when a file is removed from the list.
 * @event {{ file: FileListElement }} dds-file-click - Dispatched when a file is clicked.
 *
 * @slot delete-button - The delete button.
 *
 * @csspart base - The main file input list item container.
 * @csspart feedback - The feedback container.
 * @csspart link - The link text of the item component.
 * @csspart filename - The filename text of the item component.
 * @csspart filesize - The filesize text of the item component.
 * @csspart spinner - The spinner of the item component.
 * @csspart remove-button - The remove button of the item component.
 * @csspart thumbnail - The thumbnail of the item component.
 *
 * @cssproperty --dds-file-list-item-padding - The padding of the file list item.
 * @cssproperty --dds-file-list-item-border-width - The border width of the file list item.
 * @cssproperty --dds-file-list-item-border-color - The border color of the file list item.
 * @cssproperty --dds-file-list-item-border-radius - The border radius of the file list item.
 * @cssproperty --dds-file-list-item-bg-color - The background color of the file list item.
 * @cssproperty --dds-file-list-item-font-weight - The font weight of the file list item.
 * @cssproperty --dds-file-list-item-disabled-bg-color - The background color of the disabled file list item.
 * @cssproperty --dds-file-list-item-disabled-color - The text color of the disabled file list item.
 * @cssproperty --dds-file-list-item-content-margin - The margin of the content within the file list item.
 * @cssproperty --dds-file-list-item-content-gap - The gap between content elements in the file list item.
 * @cssproperty --dds-file-list-item-filename-color - The color of the filename text.
 * @cssproperty --dds-file-list-item-filesize-color - The color of the filesize text.
 * @cssproperty --dds-file-list-item-feedback-padding-x - The padding of the feedback section.
 * @cssproperty --dds-file-list-item-feedback-padding-y - The padding of the feedback section.
 * @cssproperty --dds-file-list-item-feedback-border-color - The border color of the feedback section.
 * @cssproperty --dds-file-list-item-feedback-font-size - The font size of the feedback text.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsFileRemove: 'dds-file-remove' as EventName<DdsFileRemoveEvent>,
onDdsFileClick: 'dds-file-click' as EventName<DdsFileClickEvent>
        },
        displayName: "DapDSFileInputListItem"
      })

      export default reactWrapper
    